module.exports = __webpack_public_path__ + "img/footimgone.9e238849.png";